/// <reference path="triggers.ts" />
/// <reference path="elements/filter.ts" />
/// <reference path="elements/map.ts" />
/// <reference path="global.ts" />
/// <reference path="elements/header.ts" />
/// <reference path="elements/slick-slider.ts" />
/// <reference path="elements/intro-slider.ts" />
/// <reference path="elements/Animations.ts" />
/// <reference path="elements/scroll-control.ts" />
/// <reference path="elements/progress-bar.ts" />
/// <reference path="elements/sideScroll.ts" />

var w: any = {};
var Snap: any;

w.controller = new ScrollMagic.Controller();
w.html = document.querySelector('html');
w.body = w.html.querySelector('body');
w.page = w.body.querySelector('.page');
w.width = window.innerWidth;
w.height = window.innerHeight;
w.webGLScenes = [];

document.addEventListener('DOMContentLoaded', ()=>{
//navigation
    new Nav();

//intro slider
    new IntroSlider();

//slick slider
    let logosSlickSettings = {
        dots: true,
        mobileFirst: true,
        arrows: false,
        slidesToShow: 2,
        centerMode: true,
        accessibility: false,
        swipeToSlide: true,
        slidesPerRow: 1,
        rows: 2,
        autoplay: true,
        autoplaySpeed: 3000,
    };

    let personSlickSettings = {
        dots: true,
        mobileFirst: true,
        arrows: false,
        centerMode: true,
        accessibility: false,
        swipeToSlide: true,
        autoplay: true,
        autoplaySpeed: 10000
    };

    let referenceSlickSettings = {
        dots: true,
        arrows: false,
        accessibility: false,
        swipeToSlide: true,
        autoplay: true,
        autoplaySpeed: 6000
    };

    let sliderLogos = document.querySelector('.slidethis--logos');
    let sliderPersons = document.querySelector('.slidethis');
    let sliderReferences = document.querySelector('.slidethis--reference');

    new InterSectionScroll();

    if (sliderLogos) {
        new Slider($('.slidethis--logos'), logosSlickSettings, 601);
    }

    if (sliderReferences) {
        new Slider($('.slidethis--reference'), referenceSlickSettings, 9999);
    }

    let people = $(".staff__column");

    if (sliderPersons && people.length > 1) {
        new Slider($('.slidethis'), personSlickSettings, 601);
    }
    let picture = document.querySelectorAll("picture:not(.static)");

    Array.prototype.forEach.call(picture, (el: any, id: any) => {
            new PictureControl(el, id);
        }
    );



//smooth scroll
    let scrolled = false;

    resize();

    function resize() {
        let slickreference = $('.slidethis--scroll');

        let slicklis = slickreference.find('.slick-dots li:first-child');

        let Slickscene = new ScrollMagic.Scene({
            triggerElement: '.slidethis--scroll',
            reverse:true,
            duration: slickreference.height() + 300,
            offset: - 150
        })
        .on('enter', () => {
             slicklis.click();
        })

        .addTo(Global.controller);


        if (window.location.hash && !scrolled) {
            const target = $(window.location.hash);
            if (!target.length) return false;

            const offset = $('header').outerHeight();
            const targetWithOffset = target.offset().top// - offset;

            animatedScrollTo(targetWithOffset, window, 0.8, 0);
            scrolled = true;
        }
    }

    $('body').on('click', '[data-scroll]', function (e) {
        var $this = $(this);
        var target = $($this.attr('data-scroll'));
        let html = $('html');
        let timeline = new TimelineMax();
        let nav = document.querySelector(".header__menu");
        let hamburger = document.querySelector('#hamburger');

        if(html.hasClass("show")) {
            timeline
                .to(nav, 0.3, {
                    left: "100%",
                    ease: Power3.easeOut
                })

            hamburger.classList.remove('close');
            html.removeClass('show');

        }

        if (!target.length) {
            return true;
        } else {
            e.preventDefault();
        }

        var element: any = $($this.attr('data-element'));
        var attrDelay = $this.attr('data-delay');
        var attrDuration = $this.attr('data-duration');
        var attrOffset = $this.attr('data-offset');

        var delay = 0;
        var duration = .8;
        var offset = 0;

        // if delay and duration ware set up
        if (typeof element !== typeof undefined) {
            element = window;
        }
        if (typeof attrDelay !== typeof undefined) {
            delay = parseInt(attrDelay);
        }
        if (typeof attrDuration !== typeof undefined) {
            duration = parseInt(attrDuration);
        }
        if (typeof attrOffset !== typeof undefined) {
            offset = parseInt(attrOffset);
        }


        var targetWithOffset = target.offset().top + offset;

        animatedScrollTo(targetWithOffset, window, duration, delay);
    });

    Global.pageProgress = new progressBar();
    let sideTargets = document.querySelectorAll('[data-anim-side]');
    if(sideTargets) {
        Array.prototype.forEach.call(sideTargets, (sideTarget:any)=>{
			new sideScroll($(sideTarget));
        });
    }
});
